import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import './About.css';

function About() {
  const objectives = [
    "To promote and develop badminton at the grassroots level.",
    "To organize regional, national, and international tournaments.",
    "To offer structured coaching programs for players.",
    "To collaborate with schools, colleges, and other institutions to increase participation in the sport."
  ];

  const featuredLeaders = [
    { name: "Sh. Priyank Bharti, IAS", title: "Patron", badge: "Patron" },
    { name: "Vijayendra Kumar, IAS", title: "President", badge: "President" }
  ];

  const keyExecutives = [
    { role: "Sr. Vice President (Administration)", name: "Surinder Mahajan" },
    { role: "Sr. Vice President (Technical & Events)", name: "Col. Raj Parmar" },
    { role: "Honorary General Secretary", name: "Geeta Aggarwal" },
    { role: "Treasurer", name: "C.A. Paras Gupta" },
    { role: "Advisor", name: "T.P.S. Puri" }
  ];

  const vicePresidents = [
    "Dr. Rakesh Malik", "Ravinder Talwar", "Rajneesh Bhatia", 
    "Col. Rajeev Mehta", "Amarinder S. Kang", "Sandeep Rishi"
  ];

  const jointSecretaries = [
    "Akash Sethi", "Pankaj Naithani", "Naresh Kundu"
  ];

  const members = [
    "Vikas Mahajan", "Dr. Anju Lata", "Ms. Sargun R. Arora", 
    "Ms. Mala Gaba", "Vijay Sharma", "Haroon Rashid"
  ];

  const technicalAdvisors = [
    "Vivek Sharma", "Bhuwan Sethi"
  ];

  return (
    <div className="about-page-wrapper container py-5">
      <h2 className="text-center mb-4 about-title text-gradient text-uppercase">About Us</h2>

      {/* Intro section */}
      <Card className="about-intro-card p-4 mb-5 border-0">
        <Card.Body className="p-0">
          <p className="about-description">
            The <strong>Chandigarh Badminton Association (Regd.)</strong>, affiliated with the <strong>Badminton Association of India</strong>, is dedicated to promoting the sport of badminton across the region. Our association aims to nurture talent, conduct top-tier tournaments, and provide professional coaching to badminton enthusiasts of all levels.
          </p>
          <p className="about-description">
            A key highlight of CBA’s commitment to excellence is our state-of-the-art Center of Excellence located at Sector 38 West Sports Complex, Chandigarh. This premier facility is equipped with advanced training infrastructure, world-class courts, and professional coaching staff. The center serves as a hub for elite training and provides aspiring players with a platform to reach national and international standards.
          </p>
          <p className="about-description mb-0">
            Beyond competitive badminton, CBA emphasizes inclusivity by organizing community events, recreational leagues, and coaching programs for players of all skill levels. Whether you are a beginner looking to learn the game or an experienced player seeking high-level competition, CBA ensures that badminton is truly a sport for all in the city.
          </p>
        </Card.Body>
      </Card>

      <Row className="mb-5 gy-4">
        <Col md={6}>
          <div className="p-4 bg-white rounded shadow-sm border-top border-4 border-success h-100">
            <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "var(--yonex-blue)" }}>
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16" className="me-2 text-success">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02-.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
              Our Vision
            </h4>
            <p className="about-description mb-0">
              We strive to make Chandigarh a hub for badminton excellence by fostering young talent, organizing competitive events, and enhancing the overall infrastructure for the sport.
            </p>
          </div>
        </Col>
        <Col md={6}>
          <div className="p-4 bg-white rounded shadow-sm border-top border-4 border-primary h-100">
            <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "var(--yonex-blue)" }}>
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16" className="me-2 text-primary">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
              </svg>
              Key Objectives
            </h4>
            <ul className="list-unstyled mb-0">
              {objectives.map((obj, index) => (
                <li key={index} className="d-flex align-items-start mb-2 small">
                  <span className="text-primary me-2 fw-bold">▪</span>
                  <span className="text-muted">{obj}</span>
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>

      {/* Featured Leaders Section */}
      <h3 className="about-section-header">Patrons & Leadership</h3>
      <Row className="g-4 mb-5">
        {featuredLeaders.map((leader, index) => (
          <Col md={6} key={index}>
            <Card className="leader-featured-card p-4">
              <Card.Body className="d-flex align-items-center p-0">
                <div className="flex-grow-1">
                  <span className="leader-badge">{leader.badge}</span>
                  <h4 className="leader-name">{leader.name}</h4>
                  <p className="leader-title text-muted mb-0">{leader.title}, Chandigarh Badminton Association</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Executive Team Table List */}
      <h3 className="about-section-header">Key Executive Members</h3>
      <div className="member-list-wrapper mb-5">
        {keyExecutives.map((exec, index) => (
          <div key={index} className="member-row-item">
            <span className="member-role-label">{exec.role}</span>
            <span className="member-name-value">{exec.name}</span>
          </div>
        ))}
      </div>

      {/* Secondary Lists Grid */}
      <Row className="gy-5">
        <Col lg={6}>
          <h4 className="about-section-header mt-0">Vice Presidents</h4>
          <div className="badge-grid">
            {vicePresidents.map((name, index) => (
              <div key={index} className="badge-card">
                <p className="badge-card-name">{name}</p>
              </div>
            ))}
          </div>
        </Col>

        <Col lg={6}>
          <h4 className="about-section-header mt-0">Joint Secretaries</h4>
          <div className="badge-grid">
            {jointSecretaries.map((name, index) => (
              <div key={index} className="badge-card">
                <p className="badge-card-name">{name}</p>
              </div>
            ))}
          </div>
        </Col>

        <Col lg={6}>
          <h4 className="about-section-header mt-0">Committee Members</h4>
          <div className="badge-grid">
            {members.map((name, index) => (
              <div key={index} className="badge-card">
                <p className="badge-card-name">{name}</p>
              </div>
            ))}
          </div>
        </Col>

        <Col lg={6}>
          <h4 className="about-section-header mt-0">Technical Advisors</h4>
          <div className="badge-grid">
            {technicalAdvisors.map((name, index) => (
              <div key={index} className="badge-card">
                <p className="badge-card-name">{name}</p>
              </div>
            ))}
          </div>
        </Col>
      </Row>

      <p className="about-description text-center text-muted mt-5 mb-0 italic">
        Additionally, we have a committed team of Vice Presidents, Joint Secretaries, and Members actively contributing to various sub-committees including finance, coaching, development, and technical advisory.
      </p>
    </div>
  );
}

export default About;
